// https://vuex.vuejs.org/en/getters.html

export default {
  getActiveTab: (state) => {
    return state.activeTab
  },
  AllProjects (state) {
    return state.projects
  },
  getProject (state) {
    return state.form
  },
}
